import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getTasksById } from '../../store/Tasks/Task/taskSlice';
// import { useTranslation } from 'react-i18next';

const useGetTaskById = ({ id }: { id: string }) => {
  const dispatch = useAppDispatch();

  // const { i18n, t } = useTranslation();
  const { TasksById, loading2: loading, error2: error } = useAppSelector(state => state.Tasks);

  useEffect(() => {
    dispatch(getTasksById(id));
  }, [id]);

  return { TasksById, loading, error };
};

export default useGetTaskById;
